import { Button, ButtonProps } from "@mui/material";
import { Eye } from "asset";
import { memo } from "react";

interface Props extends ButtonProps {
}

const ButtonDetail = memo(({ ...rest }: Props) => {

  return (
    <Button
      sx={{
        minWidth: '38px !important',
        height: '32px',
        '&.MuiButton-root': {
          p: '0px !important',
        },
      }}
      variant="contained"
      color="secondary"
      {...rest}
    >
      <Eye />
    </Button>
  )
})

export default ButtonDetail